import { Plugin, type PluginKey } from '@tiptap/pm/state';
import { type NodeType } from '@tiptap/pm/model';

export function doubleClickSelectPlugin(
	this: {
		name: string;
		editor: {
			commands: {
				setTextSelection: (params: {
					from: number;
					to: number;
				}) => void;
			};
		};
		type: NodeType;
	},
	pluginKey: PluginKey
) {
	return new Plugin({
		key: pluginKey,
		props: {
			handleDoubleClickOn: (_view, pos, node) => {
				if (node.type.name !== this.type.name) {
					return false;
				}

				this.editor.commands.setTextSelection({
					from: pos,
					to: pos + 1,
				});

				return true;
			},
		},
	});
}
